import { UPLOAD_BRAND_IMAGE_REQUEST, UPLOAD_BRAND_IMAGE_SUCCESS, UPLOAD_BRAND_IMAGE_FAILURE, UPLOAD_BRAND_IMAGE_RESET, } from "../../actions";
const initialState = {
    uploading: false,
    success: false,
    error: null,
    data: null,
};
const brandImageUploadReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_BRAND_IMAGE_REQUEST:
            return Object.assign(Object.assign({}, state), { uploading: true, success: false, error: null });
        case UPLOAD_BRAND_IMAGE_SUCCESS:
            return Object.assign(Object.assign({}, state), { uploading: false, success: true, error: null, data: action.payload });
        case UPLOAD_BRAND_IMAGE_FAILURE:
            return Object.assign(Object.assign({}, state), { uploading: false, success: false, error: action.payload });
        case UPLOAD_BRAND_IMAGE_RESET:
            return Object.assign(Object.assign({}, state), { uploading: false, success: false, error: null, data: null });
        default:
            return state;
    }
};
export default brandImageUploadReducer;
